import PolicyDriverInfo from 'edge/policy/pa/directives/PolicyDriverInfo';
import PolicyVehicleInfo from 'edge/policy/pa/directives/PolicyVehicleInfo';
import 'edge/policy/common/app';

export default angular.module('edge.policy.pa.app', ['edge.policy.common.app']).directive('gwPolicyDriverInfo', PolicyDriverInfo).directive('gwPolicyVehicleInfo', PolicyVehicleInfo);